export default "/images/191d8af57071b45e4d19a586be9d881c.avif";